import { useTranslation } from 'react-i18next';

/** Skeleton-style loading state; deliberately not a spinner. */
export function FullPageSpinner() {
  const { t } = useTranslation();

  return (
    <div className="grid min-h-dvh place-items-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="h-2 w-40 overflow-hidden rounded-full bg-surface-raised">
          <div className="h-full w-1/3 animate-pulse rounded-full bg-accent" />
        </div>
        <p className="text-sm text-muted">{t('common.loading')}</p>
      </div>
    </div>
  );
}
